import { render, staticRenderFns } from "./PodcastsCategoryRadio.vue?vue&type=template&id=19655e5c"
import script from "./PodcastsCategoryRadio.vue?vue&type=script&lang=ts"
export * from "./PodcastsCategoryRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports